import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { SITE } from "@/lib/site";

export default function LogoIntro() {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const seen = sessionStorage.getItem("scharpf_intro_seen");
    if (seen) {
      setShow(false);
      return;
    }
    const t = setTimeout(() => {
      sessionStorage.setItem("scharpf_intro_seen", "1");
      setShow(false);
    }, 2600);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="logo-intro-overlay"
          initial={{ opacity: 1 }}
          exit={{ y: "-100%", opacity: 1 }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
          className="fixed inset-0 z-[100] bg-navy flex items-center justify-center overflow-hidden"
          style={{ backgroundColor: "#1e3a5f" }}
        >
          {/* Animated rays */}
          <motion.div
            className="absolute inset-0"
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.18 }}
            transition={{ duration: 1.2 }}
            style={{
              background:
                "radial-gradient(circle at 50% 50%, rgba(78,168,58,0.45) 0%, transparent 55%)",
            }}
          />
          {/* Diagonal sweep */}
          <motion.div
            initial={{ x: "-120%", skewX: -20 }}
            animate={{ x: "120%" }}
            transition={{ delay: 1.4, duration: 1.0, ease: "easeInOut" }}
            className="absolute top-0 bottom-0 w-1/3 bg-white/10"
          />

          <motion.div
            initial={{ scale: 0.6, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="relative flex flex-col items-center gap-6 px-6"
          >
            <motion.div
              initial={{ rotate: -8, scale: 0.8 }}
              animate={{ rotate: 0, scale: 1 }}
              transition={{ delay: 0.15, duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
              className="relative"
            >
              <div className="absolute -inset-6 rounded-full bg-white/10 blur-2xl" />
              <div className="relative w-44 h-44 md:w-60 md:h-60 rounded-3xl bg-white shadow-2xl ring-4 ring-white/20 p-6 flex items-center justify-center">
                <img
                  src={SITE.logo}
                  alt="Scharpf Logo"
                  className="w-full h-full object-contain"
                />
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 0.7 }}
              className="text-center"
            >
              <h1 className="font-heading text-white text-3xl md:text-5xl font-extrabold tracking-tight">
                Scharpf
              </h1>
              <div className="mt-2 text-white/70 text-sm md:text-base tracking-[0.25em] uppercase">
                Haushaltsauflösungen · Entrümpelungen
              </div>
              <div className="mt-5 flex justify-center">
                <motion.div
                  initial={{ width: 0 }}
                  animate={{ width: "5rem" }}
                  transition={{ delay: 1.0, duration: 0.8 }}
                  className="h-[3px] bg-green-accent rounded-full"
                  style={{ backgroundColor: "#4ea83a" }}
                />
              </div>
            </motion.div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
